import { useServices } from 'containers/services';
import { useQuery, type UseQueryOptions, type UseQueryResult } from 'react-query';
import { QUERY_KEYS } from 'utils/queryKeys';
import type { GetMeterModelsArg, GetMeterModelsWithCountResponse } from '../../../lib/services';

export const useMeterModels = (
  filter: GetMeterModelsArg['filter'] = {},
  options?: UseQueryOptions<GetMeterModelsWithCountResponse>,
): UseQueryResult<GetMeterModelsWithCountResponse> => {
  const { meterModelsApiClient } = useServices();

  return useQuery({
    queryKey: QUERY_KEYS.meterModels.filter(filter),
    queryFn: async ({ signal }) => await meterModelsApiClient.find({ filter, signal }),
    ...options,
  });
};
